import classNames from 'classnames';

const STEPS = [
    { id: 1, label: 'URL' },
    { id: 2, label: 'Credentials' },
    { id: 3, label: 'Test plan' },
    { id: 4, label: 'Review' },
    { id: 5, label: 'Run' }
];

export const WizardProgress = ({ current }) => (

    <div className="d-flex align-items-center justify-content-center my-4 gap-2 flex-wrap">

        {STEPS.map((s, i) => (

            <div className="d-flex align-items-center gap-2" key={s.id}>

                <div
                    className={classNames(
                        'd-flex align-items-center justify-content-center rounded-circle',
                        s.id === current ? 'bg-primary text-white'
                            : s.id < current ? 'bg-success text-white'
                                : 'bg-secondary-subtle text-muted'
                    )}
                    style={{ fontSize: 13, fontWeight: 600, height: 28, width: 28 }}
                >
                    {s.id < current ? '✓' : s.id}
                </div>

                <small className={classNames(s.id === current ? 'fw-bold' : 'text-muted')}>
                    {s.label}
                </small>

                {i < STEPS.length - 1 && (
                    <span className="text-muted mx-1">
                        ─
                    </span>
                )}

            </div>

        ))}

    </div>

);
